<script>
    // import ProgressCircle from 'svelte-progresscircle';
    import DalleLoader from "../molecules/DalleLoader/DalleLoader.svelte";

    export let draft = true;
    export let time = 2000;

    let message = '';
    let value = 0;
    let interval = setInterval(progress, time/100);

    function progress() {
        if (value === 100) {
            clearInterval(interval);
        } else {
            value++; 
            message = messages();
        }
    }

    function messages() {
        if(draft) {
            return 'Saving draft...'
        } else if(!draft && value < 50) {
            return 'Saving your idea...'
        } else {
            return 'Publishing idea...'
        }
    }

</script>
<style>
    .lock {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        --progress-color: white;
        --progress-trackcolor: transparent;
        --progress-fill: transparent;
        --progress-width: 1px;
        --progress-trackwidth: 2px;
    }

    /* .lock__icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .lock__message {
        margin-top: 2rem;
    }

    .lockring {
        animation: lockring 3s infinite ease-in-out;
    } */

    /* @keyframes lockring {
        0% {
            transform: translate3d(0, 0, 0);
        }

        50% {
            transform: translate3d(0, -15%, 0);
        }

        100% {
            transform: translate3d(0, 0, 0);
        }
    } */
</style>
<div class="lock">
    <DalleLoader {message}></DalleLoader>
    <!-- <ProgressCircle max="100" value={value}>
        <div class="lock__icon">
            {#if draft}
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><defs><clipPath id="a"><path d="M0 0h48v48H0z"/></clipPath></defs><g clip-path="url(#a)"><path class="lockring" fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" d="M13.656 25.76v-8.708S13.656 8 23.812 8s10.156 9.052 10.156 9.052v1.6"/><rect width="40" height="25" fill="#0023f5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="1" transform="translate(4 19)"/><text fill="#fff" font-family="SF Pro" font-size="6" font-weight="500" transform="translate(14 34)"><tspan x="0" y="0">DRAFT</tspan></text></g></svg>
            {:else}
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><defs><clipPath id="a"><path d="M0 0h48v48H0z"/></clipPath></defs><g clip-path="url(#a)"><path class="lockring" d="M13.656 25.76v-8.708S13.656 8 23.812 8s10.156 9.052 10.156 9.052v1.6" fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/><rect width="40" height="25" rx="1" transform="translate(4 19)" fill="#0023f5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path d="M21.923 39l1.25-7.434-2.679.739 5.178-9.3-1.607 7.038 3.095-.875z" fill="#fff"/></g></svg>    
            {/if}
        </div>
    </ProgressCircle> -->
    <!-- <div class="lock__message">
        {message}
    </div> -->
</div>